export default {
  FILTERS_CRITERIA_LABEL: 'Criteria',
  FILTERS_OPERATOR_LABEL: 'Operator',
  OPERATOR_IS: 'Is',
  OPERATOR_IS_NOT: 'Not',
  OPERATOR_CONTAINS: 'Contains',
  OPERATOR_NOT_CONTAINS: 'Does not contain',
  OPERATOR_LESS_THAN: 'Less than',
  OPERATOR_GREATER_THAN: 'Greater than',
  OPERATOR_ANY: 'Any',
  OPERATOR_ALL: 'All',
  OPERATOR_IS_NULL: 'Empty',
  OPERATOR_IS_NOT_NULL: 'Known',
  OPERATOR_NONE_OF: 'None of',
  OPERATOR_BETWEEN: 'Between',
  AND: 'And',
  DUPLICATE_FILTER: 'Duplicate',
  REMOVE_FILTER: 'Remove',
  CONSTITUENT_FILTERS: 'Constituent filters',
  CONTRIBUTION_FILTERS: 'Contribution filters',
};
